<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <span 
            matTooltip="Export to Excel" 
            matTooltipPosition="left" 
            matTooltipClass="custom-orange-tooltip">
            <app-print-button (togglePrint)="print()"></app-print-button>
        </span>
    </app-tab-header>
    <div class="w-900-px mx-auto">
        <form [formGroup]="form">
            <div class="grid grid-cols-9 gap-3">
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-106-px font-semibold">First Name:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="firstName" type="text" placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-141-px font-semibold">Middle Name:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="middleName" type="text" placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-106-px font-semibold">Last Name:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="lastName" type="text" placeholder="Last Name">
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-9 gap-3 mt-3">
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Transaction ID:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" formControlName="transactionId" type="text" placeholder="Transaction ID">
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input class="w-full" label="Date From:" [parentForm]="form" controlName="dateFrom"></app-date-input>
                    </div>
                </div>
                <div class="col-span-3">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input class="w-full" label="Date To:" [parentForm]="form" controlName="dateTo"></app-date-input>
                    </div>
                </div>
            </div>
        </form>
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button (click)="submit()" class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
    </div>

    <div *ngIf="showTable">
        <div *ngIf="submitted">

            <app-table-controls
                [currentLimit]="activeLimit?.size ?? 10"
                [showLimitControl]="true"
                [showSearchControl]="true"
                (limitChangeEvent)="activeLimit?.onLimitChange($event)"
                (searchKeyupEvent)="activeSearch?.onSearchKeyup($event)"
                (keydownEvent)="keyDownFunction($event)"
            ></app-table-controls>

            <div class="bg-light-orange w-full maxh-550-px px-3 overflow-x-auto w-table">
                <div class="data-table4 mt-3 barlow text-xs" style="font-size: 10px;">
                    <table class="w-full">
                        <thead>
                            <tr>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    TRANSACTION ID
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('transactionId')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    CUSTOMER NAME
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('customerName')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    ACCOUNT STATUS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('accountStatus')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    TYPE OF TRANSACTION
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('transactionType')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    DATE/TIME
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('dateTime')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    AMOUNT SPENT
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('amountSpent')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    EARNED POINTS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('earnedPoints')">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="focus:outline-none" *ngFor="let item of activeList">
                                <td>{{ item.transactionId | nullWithDefault }}</td>
                                <td>{{ item.customerName | nullWithDefault | titlecase }}</td>
                                <td>{{ item.accountStatus | nullWithDefault }}</td>
                                <td>{{ item.transactionType | nullWithDefault }}</td>
                                <td>{{ item.dateTime | nullWithDefault | date:' yyyy-dd-MM  hh:mm:ss' }}</td>
                                <td>{{ item.amountSpent | nullWithDefault }}</td>
                                <td>{{ item.earnedPoints | nullWithDefault }}</td>
                            </tr>

                            <!-- Loading state -->
                            <tr *ngIf="isLoadingData">
                                <td colspan="10" class="text-center py-10 text-gray-500">
                                    <div class="flex flex-col items-center justify-center gap-2">
                                        <span class="italic text-xs">Loading data, please wait...</span>
                                    </div>
                                </td>
                            </tr>

                            <!-- Empty state (only shown after loading completes) -->
                            <tr *ngIf="!isLoadingData && (!activeList || activeList.length === 0)">
                                <td colspan="10" class="text-center py-10 text-gray-500">
                                    <div class="flex flex-col items-center justify-center gap-2">
                                        <img src="../../../../assets/images/icon/no-data.webp"
                                            alt="No Data"
                                            style="height: 48px; opacity: 0.4;"
                                            onerror="this.style.display='none'">
                                        <span class="font-semibold text-xs uppercase tracking-wide">No records found</span>
                                        <span class="italic text-xs">Try adjusting your search or filter criteria.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <app-pagination
                backgroundColor="bg-light-orange"
                [showTotalEntries]="true"
                [currentPage]="activePage?.current ?? 1"
                [totalPages]="activePage?.total ?? 1"
                [pageSize]="activeLimit?.size ?? 10"
                [totalItems]="activeLimit?.total ?? 0"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                (pageChange)="setPage($event)"
            ></app-pagination>
        </div>
    </div>
</div>
<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>